import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText } from '@mui/material';
import { useWebSocket } from '../../contexts/WebSocketContext';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';
import './NavSection.css';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  const usuario = JSON.parse(localStorage.getItem('userData'));
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) =>
          !item.supervisor || item.supervisor === usuario?.supervisor ? <NavItem key={item.title} item={item} /> : null
        )}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;
  const { unreadCount } = useWebSocket();

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} />

      {info && info}

      {title === 'Chamados' && unreadCount.chamadosCount > 0 && (
        <span className="notification-badge">{unreadCount.chamadosCount}</span>
      )}
      {title === 'Cronograma' && unreadCount.osCount > 0 && (
        <span className="notification-badge">{unreadCount.osCount}</span>
      )}
    </StyledNavItem>
  );
}
